/**
 * Read-only Supabase client for the BuxBox Story Builder database.
 * Used to fetch book content, pages, characters, and music tracks directly.
 * 
 * These are publishable anon keys — safe to include in client code.
 * The Builder DB has open RLS (FOR ALL USING (true)) on content tables.
 */
import { createClient } from '@supabase/supabase-js';

const BUILDER_URL = 'https://vuekzeutmcuvvihsjrdc.supabase.co';
const BUILDER_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ1ZWt6ZXV0bWN1dnZpaHNqcmRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5MDM0MTMsImV4cCI6MjA4OTQ3OTQxM30.quUcCym3wkx-TTLHHgcoD0iz4Z8X4kWnn-ZN4LWLzEw';

export const builderSupabase = createClient(BUILDER_URL, BUILDER_ANON_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
});
